import { render, staticRenderFns } from "./marketRuleList.vue?vue&type=template&id=499533d0&scoped=true"
import script from "./marketRuleList.vue?vue&type=script&lang=js"
export * from "./marketRuleList.vue?vue&type=script&lang=js"
import style0 from "./marketRuleList.vue?vue&type=style&index=0&id=499533d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499533d0",
  null
  
)

export default component.exports